import * as actions from '../actionTypes';

import tasPink from '../../assets/img/tas-pink/tas-pink.png';
import dompetCoklat from '../../assets/img/dompet-coklat/dompet-coklat.png';
import sofaIjo from '../../assets/img/sofa-ijo/sofa-ijo.png';
import sabunMuka from '../../assets/img/sabun-muka/sabun-muka.png';
import sabunBatang from '../../assets/img/sabun-batang/sabun-batang.png';

const initialFlashSaleState = {
  timerFlashSale: {
    startTimer: '11/26/2020 21:40',
    endTimer: '12/20/2020 00:00'
  },
  items: [
    {
      id: 'pink-soap',
      productName: 'Pink Soap',
      qty: 78,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunBatang,
      alt: 'sabun batang'
    },
    {
      id: 'white-skin-cream-whitening',
      productName: 'White Skin Cream Whitening',
      qty: 21,
      discount: '70%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunMuka,
      alt: 'sabun muka'
    },
    {
      id: 'tas-selempang-wanita',
      productName: 'Tas Selempang Wanita',
      qty: 1,
      discount: '20%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: tasPink,
      alt: 'tas pink'
    },
    {
      id: 'dompet-kulit-pria',
      productName: 'Dompet Kulit Pria',
      qty: 3,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: dompetCoklat,
      alt: 'dompet coklat'
    },
    {
      id: 'sofa-hijau',
      productName: 'Sofa Hijau',
      qty: 1,
      discount: '10%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sofaIjo,
      alt: 'kursi hijau'
    },
    {
      id: 'pink-soap2',
      productName: 'Pink Soap',
      qty: 78,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunBatang,
      alt: 'sabun batang'
    },
    {
      id: 'white-skin-cream-whitening2',
      productName: 'White Skin Cream Whitening White Skin Cream Whitening',
      qty: 21,
      discount: '70%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sabunMuka,
      alt: 'sabun muka'
    },
    {
      id: 'tas-selempang-wanita2',
      productName: 'Tas Selempang Wanita Tas Selempang Wanita',
      qty: 1,
      discount: '20%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: tasPink,
      alt: 'tas pink'
    },
    {
      id: 'dompet-kulit-pria2',
      productName: 'Dompet Kulit Pria Dompet Kulit Pria',
      qty: 3,
      discount: '50%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: dompetCoklat,
      alt: 'dompet coklat'
    },
    {
      id: 'sofa-hijau2',
      productName: 'Sofa Hijau',
      qty: 1,
      discount: '10%',
      discountPrice: '30.000',
      actualPrice: '15.000',
      img: sofaIjo,
      alt: 'kursi hijau'
    }
  ]
}

const flashSaleReducer = (state = initialFlashSaleState, action) => {
  if (action.type === actions.FLASHSALE_TIMER_SETED) {
    return { ...state, timerFlashSale: action.payload }
  }

  return state;
}

export default flashSaleReducer;